import React from "react";
import RouteLine from "./RouteLine";

interface RouteLegendProps {
    showCurrentRoute?: boolean;
    showSuggestedRoute?: boolean;
}

const RouteLegend: React.FC<RouteLegendProps> = ({
    showCurrentRoute = true,
    showSuggestedRoute = true
}) => {
    return (
        <div className="padding-top-15">
            <div className="display-flex flex-column gap-8 bg-white rounded padding-2 padding-left-10 padding-right-10 border border-primary">
                <div className="display-flex align-items-center width-100pct gap-10">
                    <RouteLine
                        label="Caminho atual"
                        bgColor="bg-highlight"
                        enabled={showCurrentRoute}
                    />
                    <RouteLine
                        label="Caminho sugerido"
                        bgColor="bg-rating-4"
                        enabled={showSuggestedRoute}
                    />
                </div>
            </div>
        </div>
    );
};

export default RouteLegend;

